import React from "react"
import InfiniteSelectDropdown, { SelectOption } from "./InfiniteSelectDropdown"
import { getAllUsers, USER } from "../../service/user"

interface StaffDropdownProps {
  // value?: SelectOption[] | SelectOption
  // onChange: (selectedStaff: SelectOption[] | SelectOption) => void
  value?: any
  onChange: (selectedStaff: any) => void
  placeholder?: string
  isMulti?: boolean
  className?: string
  isDisabled?: boolean
  limit?: number
  // Additional filters for staff
  filters?: {
    role?: string
    status?: string
    sortBy?: string
    sortOrder?: string
  }
}

const StaffDropdown: React.FC<StaffDropdownProps> = ({
  value = [],
  onChange,
  placeholder = "Select staff members",
  isMulti = true,
  className,
  isDisabled = false,
  limit = 10,
  filters = {},
}) => {
  const fetchStaffData = async ({
    page,
    limit: pageLimit,
    searchText,
  }: {
    page: number
    limit: number
    searchText?: string
  }) => {
    const response = await getAllUsers({
      page,
      limit: pageLimit,
      searchText,
      ...filters, // Include additional filters like role, status, etc.
    })

    return {
      data: response.data,
      pagination: response.pagination,
    }
  }

  const formatStaffOption = (user: USER): SelectOption => {
    const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim()
    const employeeId = user.employeeID
      ? ` (${typeof user.employeeID === "string" ? user.employeeID : user.employeeID.employeeID})`
      : ""
    const department = user.department ? ` - ${user.department}` : ""
    const designation = user.designation ? ` (${user.designation})` : ""

    return {
      value: user._id,
      label: `${fullName}${employeeId}${department}${designation}`,
    }
  }

  return (
    <InfiniteSelectDropdown<USER>
      fetchData={fetchStaffData}
      formatOption={formatStaffOption}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      className={className}
      isDisabled={isDisabled}
      limit={limit}
    />
  )
}

export default StaffDropdown
